module.exports = __webpack_public_path__ + "assets/img/eighth_user.2f844208.png";